export default __webpack_public_path__ + "static/media/google.70fecf69.svg";